import { ProductAdditives } from '../../../../services/exports/Constants';

export default {
  title: 'Toevoegingen',
  options: {
    [ProductAdditives.AcesulfamK]: 'Acesulfaam K',
    [ProductAdditives.AceSucralose]: 'Ace-Sucralose',
    [ProductAdditives.Aesculin]: 'Esculine',
    [ProductAdditives.Agar]: 'Agar',
    [ProductAdditives.Anthocyanin]: 'Anthocyaan',
    [ProductAdditives.Antioxidant]: 'Antioxidant',
    [ProductAdditives.AntioxidantAscorbicAcid]: 'Antioxidant: Ascorbinezuur',
    [ProductAdditives.AntioxidantTocopherols]: 'Antioxidant: Tocoferolen',
    [ProductAdditives.Flavor]: 'Aroma',
    [ProductAdditives.Flavors]: "Aroma's",
    [ProductAdditives.AscorbicAcid]: 'Ascorbinezuur',
    [ProductAdditives.Aspartame]: 'Aspartaam',
    [ProductAdditives.OysterSauce]: 'Oestersaus',
    [ProductAdditives.BakingAid]: 'Bakhulpmiddel',
    [ProductAdditives.BakingPowder]: 'Bakpoeder',
    [ProductAdditives.BalsamicVinegar]: 'Balsamicoazijn',
    [ProductAdditives.BalsamicCream]: 'Balsamicocrème',
    [ProductAdditives.BasilPesto]: 'Basilicumpesto',
    [ProductAdditives.BenzoicAcid]: 'Benzoëzuur',
    [ProductAdditives.BetaCarotene]: 'Bètacaroteen',
    [ProductAdditives.Betain]: 'Betaïne',
    [ProductAdditives.BeetrootRed]: 'Bietenrood',
    [ProductAdditives.Beeswax]: 'Bijenwas',
    [ProductAdditives.Bitters]: 'Bitters',
    [ProductAdditives.BlueCuracao]: 'Blue Curaçao',
    [ProductAdditives.BlueCuracaoSyrup]: 'Blue Curaçao Siroop',
    [ProductAdditives.BrandyVinegar]: 'Brandewijnazijn',
    [ProductAdditives.Broth]: 'Bouillon',
    [ProductAdditives.Caffeine]: 'Cafeïne',
    [ProductAdditives.Calcium]: 'Calcium',
    [ProductAdditives.Caramel]: 'Karamel',
    [ProductAdditives.CaramelColor]: 'Karamelkleurstof',
    [ProductAdditives.CaramelE150d]: 'Karamel E150d',
    [ProductAdditives.Carotene]: 'Caroteen',
    [ProductAdditives.CayennePepper]: 'Cayennepeper',
    [ProductAdditives.Chili]: 'Chili',
    [ProductAdditives.ChiliDressing]: 'Chilidressing',
    [ProductAdditives.ChiliMayonnaise]: 'Chilimayonaise',
    [ProductAdditives.ChiliOil]: 'Chiliolie',
    [ProductAdditives.Quinine]: 'Kinine',
    [ProductAdditives.Chlorophyll]: 'Chlorofyl',
    [ProductAdditives.CitricAcid]: 'Citroenzuur',
    [ProductAdditives.CitrusAcid]: 'Citroenzuur',
    [ProductAdditives.CarbonDioxide]: 'Koolstofdioxide (CO₂)',
    [ProductAdditives.CocktailSauce]: 'Cocktailsaus',
    [ProductAdditives.Curry]: 'Kerrie',
    [ProductAdditives.CurryPaste]: 'Kerriepasta',
    [ProductAdditives.CurryPowder]: 'Kerriepoeder',
    [ProductAdditives.CurryCreamSauce]: 'Kerrie-roomsaus',
    [ProductAdditives.Fragrance]: 'Geurstof',
  },
};
